import { render, staticRenderFns } from "./MyExercisesView.vue?vue&type=template&id=e534a34a&scoped=true&"
import script from "./MyExercisesView.vue?vue&type=script&lang=ts&"
export * from "./MyExercisesView.vue?vue&type=script&lang=ts&"
import style0 from "./MyExercisesView.vue?vue&type=style&index=0&id=e534a34a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e534a34a",
  null
  
)

export default component.exports